import React, { createContext, useContext, useState, useCallback } from 'react';

const EditContext = createContext();

// Hook to access the edit mode state
export const useEditMode = () => useContext(EditContext);

export const EditProvider = ({ children }) => {
    const [isEditMode, setEditMode] = useState(false);

    const toggleEditMode = useCallback(() => {
        setEditMode(prevMode => !prevMode);
    }, []);

    const value = {
        isEditMode,
        setEditMode,
        toggleEditMode
    };

    return (
        <EditContext.Provider value={value}>
            {children}
        </EditContext.Provider>
    );
};
